<template>
  <v-window
    v-model="window"
    data-kp-anchor="layout.default.menu"
  >
    <v-window-item>
      <v-list
        nav
        open-strategy="single"
        slim
        class="pb-12"
      >
        <KpNavigationFavorites />
        <v-divider class="pb-1" />
        <KpNavigationDashboardsAndTables />
        <v-divider />
        <KpNavigationDrawerItem
          :enable-favorite="false"
          :title="t('common.settings')"
          class="mt-2"
          icon="settings no-fill"
          @click="window = 1"
        />
      </v-list>
    </v-window-item>
    <v-window-item>
      <!-- Settings drawer content -->
      <v-list
        class="py-1"
        nav
      >
        <v-list-item
          prepend-icon="chevron_backward"
          data-cy="navigation-drawer-settings-back-to-application"
          :title="t('navigation.drawer.settings.backToApplication')"
          @click="window = 0"
        />
      </v-list>
      <v-divider />
      <v-list
        class="pb-12"
        open-strategy="single"
        :items="items"
        nav
      >
        <template #title="{ item, title }">
          <span
            v-tooltip="item?.props?.tooltip"
            :class="{'text-body-medium': !item?.children}"
          >{{ title }}</span>
        </template>
      </v-list>
    </v-window-item>
  </v-window>
</template>
<script setup>
import {
  computed, ref, watch,
} from 'vue';
import { useI18n } from 'vue-i18n';

import { useRoute } from 'vue-router';
import useNavigationDrawer from '~/composables/useNavigationDrawer';

import KpNavigationDashboardsAndTables from '~/layouts/KpNavigationDashboardsAndTables.vue';
import KpNavigationFavorites from '~/layouts/KpNavigationFavorites.vue';
import KpNavigationDrawerItem from '~/layouts/KpNavigationDrawerItem.vue';

const { t } = useI18n();
// Drawer content things
const { navigationDrawerSettingsItems } = useNavigationDrawer();
// The items to display in the drawer
const items = computed(() => [
  {
    title: t('common.settings'),
    props: {
      active: false,
      to: {
        name: 'settings',
      },
    },
  },
  ...navigationDrawerSettingsItems.value]);

// "window" things
const route = useRoute();
// Regarding the page we arrive at, either 0 (main drawer) or 1 (settings drawer) by default
const defaultWindow = route.fullPath.startsWith('/settings') ? 1 : 0;
/**
 * The window displayed in the drawer content (either main drawer or settings one)
 */
const window = ref(defaultWindow);
// Watch the route to update the window accordingly
watch(route, () => {
  if (route.fullPath.startsWith('/settings')) {
    window.value = 1;
  } else {
    window.value = 0;
  }
});
</script>
